import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import LinkListBlockComponent, {} from '../../../linklistblock';
import { PortableTextContext } from '../../portable-text-content';
const LinkListBlock = ({ value }) => {
    const backgroundColor = useContext(PortableTextContext)?.backgroundColor;
    return (_jsx(LinkListBlockComponent, { links: value.links, title: value.title, titleHtmlMarkup: value.titleHtmlMarkup, additionalLinkList: value.additionalLinkList, color: backgroundColor ? backgroundColor : value.color, useGridLayout: value.useGridLayout }));
};
export default LinkListBlock;
